// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2LAmf","left":"styles_left__x46xI"};